import React from 'react';
import Content from '../Content';
import BreadCrumb from '../BreadCrumb';
import PaperMeta from '../PaperMeta';
import PaperRating from '../PaperRating';

const Paper = ({ title, subtitle, meta, items, crumbs, rating }) => (
  <div className="section help-section is-relative">
        <div className="container">
            <div className="columns is-vcentered">
                <div className="column"></div>
                <div className="column is-9 help-container">
                    {
                      crumbs.length > 0
                        ? <BreadCrumb crumbs={crumbs} />
                        : ''
                    }
                    <div className="flex-card single-help-article">
                        <div className="article-inner">
                            <h2 className="title is-3 dark-text">
                                {title}
                            </h2>
                            {
                              subtitle
                                ? <h3 className="subtitle is-5">{subtitle}</h3>
                                : ''
                            }
                            {
                              meta.author
                                ? <PaperMeta {...meta} />
                                : ''
                            }
                            <Content items={items} />
                            {
                              rating
                                ? <PaperRating />
                                : ''
                            }
                        </div>
                    </div>
                </div>
                <div className="column"></div>
            </div>
        </div>
    </div>
);

export default Paper;
